(() => {
  const descriptionSelector =
    '.product__description, .prod__description, .sf-product__section-tabs [data-block-type="description"]';
  const imageSelector = `${descriptionSelector} img`;

  function withoutParameters(source) {
    if (!source || source.startsWith('data:') || source.startsWith('blob:')) return source;

    const hashIndex = source.indexOf('#');
    const fragment = hashIndex < 0 ? '' : source.slice(hashIndex);
    const url = hashIndex < 0 ? source : source.slice(0, hashIndex);
    const path = url.split('?')[0];
    return path.replace(/(?:&(?:amp;)?[^&/?=]+=[^&/?]*)+$/i, '') + fragment;
  }

  function fixImage(image) {
    for (const attribute of ['src', 'data-src']) {
      const current = image.getAttribute(attribute);
      const clean = withoutParameters(current);
      if (current && clean !== current) image.setAttribute(attribute, clean);
    }

    for (const attribute of ['srcset', 'data-srcset']) {
      const current = image.getAttribute(attribute);
      if (!current || current.startsWith('data:')) continue;

      const clean = current.split(',').map((candidate) => {
        const parts = candidate.trim().split(/\s+/, 2);
        return [withoutParameters(parts[0]), parts[1]].filter(Boolean).join(' ');
      }).join(', ');
      if (clean !== current) image.setAttribute(attribute, clean);
    }
  }

  function fixImages(root) {
    if (root.nodeType === Node.ELEMENT_NODE && root.matches('img') && root.closest(descriptionSelector)) {
      fixImage(root);
    }
    root.querySelectorAll?.(imageSelector).forEach(fixImage);
  }

  fixImages(document);
  document.addEventListener('shopify:section:load', (event) => fixImages(event.target));
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'attributes') {
        const image = mutation.target;
        if (image.matches('img') && image.closest(descriptionSelector)) fixImage(image);
      } else {
        mutation.addedNodes.forEach(fixImages);
      }
    }
  }).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['src', 'srcset', 'data-src', 'data-srcset'],
  });
})();
